import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
} from "@reduxjs/toolkit";
import { environment } from "../../shared/config/environment";
import axios from "axios";
import { filter } from "lodash";

const plansAdapter = createEntityAdapter();

const initialState = plansAdapter.getInitialState({
  status: false,
  currentPlanStatus: false,
  error: null,
  currentPlanError: false,
  currentPlanErrorMessage:"",
  currentPlan: {},
  addons: [],
  featureAddons: [],
  period: "yearly",
  activeFreeTrial: {},
  loading: false,
  trialError: false,
  trialStatus: false,
});

export const fetchPlans = createAsyncThunk("plans/fetch", async (args) => {

  try {
    var config = {
      method: "GET",
      url: environment.URL + `tenants/plans?flavor=${args?.flavor}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${args.access_token}`,
        "X-Tenant": args?.tenant_id
      },
    };
    const response = await axios(config);
    console.log("response", response.data)
    return response?.data?.data;
  } catch (error) {

    throw error;
  }
});

export const fetchAddons = createAsyncThunk(
  "plans/fetchAddons",
  async (args) => {
    try {
      var config = {
        method: "GET",
        url: environment.URL + `tenants/addons`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${args.access_token}`,
          "X-Tenant": args?.tenant_id
        },
      };
      const response = await axios(config);

      return response?.data?.data;
    } catch (error) {

      throw error;
    }
  }
);

export const fetchFeatureAddons = createAsyncThunk(
  "plans/fetchFeatureAddons",
  async (args) => {
    try {
      var config = {
        method: "GET",
        url: environment.URL + `tenants/feature-addons`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${args.access_token}`,
          "X-Tenant": args?.tenant_id,
        },
      };
      const response = await axios(config);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchCurrentPlanFeatures = createAsyncThunk(
  "plans/fetchCurrentPlanFeatures",
  async (args,{rejectWithValue}) => {

    try {
      var config = {
        method: "GET",
        url: environment.URL + `tenants/plan-features/` + args.tenantId,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${args.access_token}`,
          "X-Tenant": args?.tenantId
        },
      };
      const response = await axios(config);
      console.log("current plan features response", response.data)
      return response?.data;
    } catch (error) {
      console.log("error",error.response.data)
      return rejectWithValue(error.response.data);
    }
  }
);

export const activateFreeTrial = createAsyncThunk(
  "plans/activateFreeTrial",
  async (args) => {

    const data = {
      "tenant_id": args?.tenantId,
      "flavor": args?.flavor
    }
    try {
      var config = {
        method: "POST",
        url: environment.URL + `tenants/activate-trial`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${args.access_token}`,
          "X-Tenant": args?.tenant_id
        },
        data: data
      };
      const response = await axios(config);

      return response?.data;
    } catch (error) {

      throw error;
    }
  }
);

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    selectedPeriod(state, action) {
      state.period = action.payload;
    },
    resetPlans: () => initialState,
    resetError(state, action) {
      state.trialError = false;
      state.trialStatus = false
      state.currentPlanError = false;
      state.currentPlanErrorMessage = "";
      state.error = null
    }
  },

  extraReducers(builder) {
    builder
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.status = true;
        plansAdapter.upsertMany(state, action.payload);
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.status = false;
        state.currentPlanError = true;
        state.currentPlanErrorMessage = action.payload;
      })
      .addCase(fetchCurrentPlanFeatures.fulfilled, (state, action) => {
        state.currentPlanStatus = true;
        state.currentPlan = action.payload;
      })
      .addCase(fetchCurrentPlanFeatures.rejected, (state, action) => {
        state.currentPlanStatus = false;
        state.currentPlanError = true;
        state.currentPlanErrorMessage = action.payload.error;
      })
      .addCase(fetchAddons.fulfilled, (state, action) => {
        state.status = true;
        state.addons = action.payload;
      })
      .addCase(fetchAddons.rejected, (state, action) => {
        state.status = false;
        state.error = "Unable to fetch addons";
      })
      .addCase(fetchFeatureAddons.fulfilled, (state, action) => {
        state.status = true;
        state.featureAddons = action.payload || [];
      })
      .addCase(fetchFeatureAddons.rejected, (state, action) => {
        state.status = false;
        state.error = "Unable to fetch feature addons";
      })
      .addCase(activateFreeTrial.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(activateFreeTrial.fulfilled, (state, action) => {
        state.loading = false;
        state.activeFreeTrial = action.payload
        state.trialStatus = true

      })
      .addCase(activateFreeTrial.rejected, (state, action) => {
        state.loading = false;
        state.activeFreeTrial = {};
        state.trialError = true;
        state.trialStatus = false
        state.error = "Free trial has been already used. Please upgrade your plan"

      })
  },
});

export default plansSlice.reducer;

export const { resetPlans, selectedPeriod, resetError } = plansSlice.actions;

export const {
  selectAll: selectAllPlans,
  selectById: selectPlanById,
  selectIds: selectPlanIds,
} = plansAdapter.getSelectors((state) => state.plans);

export const selectPlansByPeriod = createSelector(
  [selectAllPlans, (state, period) => period],

  (plans, period) => {

    return plans.filter(
      (plan) =>
        plan.period === period || plan.label.includes("Free")
    );
  }
);
